import React from "react";
import "./FullScreenLoader.css";

const FullScreenLoader = ({
  message = "Loading...",
  subtext = "Please wait while we load your page",
}) => {
  return (
    <div className="fullscreen-loader">
      <div className="fullscreen-loader__content">
        <div className="fullscreen-loader__spinner" role="status" aria-label={message} />
        <div className="fullscreen-loader__message">{message}</div>
        {subtext && <div className="fullscreen-loader__subtext">{subtext}</div>}
      </div>
    </div>
  );
};

export default FullScreenLoader;
